import React from "react";

const CosmeticDentistry = () => {
  return (
    <div>
      <h1>CosmeticDentistry</h1>
      <p>Details about general dentistry services...</p>
    </div>
  );
};

export default CosmeticDentistry;
